import { render } from "./product-gallery-carousel.vue?vue&type=template&id=60a6f70f"
import script from "./product-gallery-carousel.vue?vue&type=script&lang=js"
export * from "./product-gallery-carousel.vue?vue&type=script&lang=js"

import "./product-gallery-carousel.vue?vue&type=style&index=0&id=60a6f70f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__